// src/components/WaitlistPopup.tsx
import { AnimatePresence, motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";

const popupVariants = {
  hidden: { opacity: 0, scale: 0.95 },
  visible: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0.95 },
};

function WaitlistPopup({ onClose }: { onClose: () => void }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [location, setLocation] = useState("");
  const [deviceInfo, setDeviceInfo] = useState({
    platform: "Unknown",
    browser: "Unknown",
  });

  const navigate = useNavigate();

  useEffect(() => {
    fetch("https://ipapi.co/json/")
      .then((res) => res.json())
      .then((data) => {
        const loc = `${data.city}, ${data.region}, ${data.country_name}`;
        setLocation(loc);
      })
      .catch(() => setLocation("Unknown"));

    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile = /android|iphone|ipad|ipod|blackberry|windows phone|mobile/i.test(userAgent);
    const platform = isMobile ? "Mobile" : "Desktop";

    let browser = "Unknown";
    if (userAgent.includes("chrome") && !userAgent.includes("edge")) browser = "Chrome";
    else if (userAgent.includes("safari") && !userAgent.includes("chrome")) browser = "Safari";
    else if (userAgent.includes("firefox")) browser = "Firefox";
    else if (userAgent.includes("edg")) browser = "Edge";
    else if (userAgent.includes("opera") || userAgent.includes("opr")) browser = "Opera";

    setDeviceInfo({ platform, browser });
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const formUrl =
      "https://docs.google.com/forms/d/e/1FAIpQLSfBVmbofSW3ol3uaQRrBF8czd4BDR_JCh8tV36WIpRCxQ-_fw/formResponse";

    const formData = new FormData();
    formData.append("entry.96017419", name);
    formData.append("entry.1491545790", email);
    formData.append("entry.742914215", location);
    formData.append("entry.328400740", deviceInfo.platform);
    formData.append("entry.64961969", deviceInfo.browser);

    await fetch(formUrl, { method: "POST", mode: "no-cors", body: formData }).catch(console.error);
    void navigate("/waitlist-confirmed");
  };

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-50 flex items-center justify-center">
        <div onClick={onClose} className="fixed inset-0 bg-[rgba(0,0,0,0.5)] backdrop-blur-sm" />
        <motion.div
          initial="hidden"
          animate="visible"
          exit="exit"
          variants={popupVariants}
          transition={{ duration: 0.3 }}
          className="relative z-50 bg-white text-white rounded-3xl shadow-2xl w-full max-w-xl m-4 md:m-0 p-4 md:p-12 space-y-4"
        >
          <button onClick={onClose} className="absolute top-2 right-5 text-gray-400 hover:text-white text-xl">×</button>
          <form onSubmit={handleSubmit}>
            <div className="pb-12 text-center">
              <h1 className="text-black text-3xl font-bold">We are almost there</h1>
              <p className="text-md text-gray-400">Be the first to know when we launch</p>
            </div>
            <div className="space-y-4">
              <input
                type="text"
                placeholder="Your name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                className="w-full h-[55px] px-4 rounded-full bg-gray-200 text-black placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-600"
              />
              <input
                type="email"
                placeholder="Your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full h-[55px] px-4 rounded-full bg-gray-200 text-black placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-600"
              />
            </div>
            <button
              type="submit"
              className="w-full mt-4 bg-black text-white font-bold h-[55px] rounded-full hover:bg-gray-600 transition"
            >
              Join Waitlist
            </button>
            <p className="pt-6 text-center text-gray-400">
              (by joining you agree to receive early access and launch updates)
            </p>
          </form>
        </motion.div>
      </div>
    </AnimatePresence>
  );
}

export default WaitlistPopup;
